import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

import { EntityConfig } from 'src/app/_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from 'src/app/_appCommon/base/EntityDataServiceBase';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';

@Injectable()
export class OpenpayService extends EntityDataServiceBase
{
  public createCardToken_WebApiMethod: string = "createCardToken";
  public charge_WebApiMethod: string = "charge";
  public chargeStore_WebApiMethod: string = "chargeStore";
  public chargeBank_WebApiMethod: string = "chargeBank";

  constructor(public http: HttpClient)
  {
    super(http, "openpay");
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();
    this.entityConfig.entityName = "openpay";
    this.entityConfig.apiUrl = "api/Openpay";
  }

  // 'body' is the 'card object'
  // Example of body content:
  /*
    this.cardObject = {
        "HolderName": "Juan Perez Ramirez",
        "CardNumber": "4111111111111111",
        "ExpirationMonth": "12",
        "ExpirationYear": "25",
        "Cvv2": "110"
    };
   */
  public generateToken(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.createUrl(this.createCardToken_WebApiMethod), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  // Example of body content:
  /*
        this.chargeObject = {
            "Method": "card",
            "SourceId": cardTokenId,
            "Amount": 100,
            "Description": "Cargo nuevo",
            "DeviceSessionId": deviceDataId,
            "CustomerName": this.cardObject.HolderName,
            "CustomerEmail": "pendiente@gmail.com"
        };
    */
  public charge(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.createUrl(this.charge_WebApiMethod), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  // Example of body content:
  /*
        this.chargeObject = {
        "Method": "store",
        "Amount": 10000,
        "Description": "Pago en tienda",
        "CustomerName": this.customerObject.CustomerName,
        "CustomerEmail": this.customerObject.CustomerEmail
        };
    */
  public chargeStore(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.createUrl(this.chargeStore_WebApiMethod), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  // Example of body content
  /*
    this.chargeObject = {
        "Method": "bank_account",
        "Amount": 10000,
        "Description": "Pago con transferencia",
        "CustomerName": this.customerObject.CustomerName,
        "CustomerEmail": this.customerObject.CustomerEmail
    };
  */
  public chargeBank(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.createUrl(this.chargeBank_WebApiMethod), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public createPDFChargeStore(body:any ): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.entityConfig.apiUrl +"/getPDFOpenPay", body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public createPDFChargeBank(body: any): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.post(this.entityConfig.apiUrl + "/getPDFSPEI", body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }
}
